import React from "react";

import { getIcon } from "../../../helpers/icons";
import Text from "../../../components/Text";

import style from "./style.module.css";

const DetailItem = ({ icon, label, children }) => {
    if (!label && !children) return null;

    return (
        <div className={style.detailItem}>
            <i className={`${getIcon(icon)} fa-fw`}></i>
            {label && <Text text={label} />}
            {children}
        </div>
    );
};

export default DetailItem;